export default function addressHasData(obj: any) {
    const objProps = ["address_line1","address_line2","city","state","state_cd","zip","county"];
    return objProps.some((prop) => {
        return obj.hasOwnProperty(prop) && obj[prop];
    });
}
